export type ApprovalEmailContract = {
    emailType: number,
    requestId: number,
    emailSubject: string,
    firstParagraph: string, 
    emailContent: string,
}